import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { Button } from "../../../components/Button";
import "./styles.less";

export const ZeroSecurity = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="zero-trust-security">
        <div className="inner">
          <div className="title">{t("zeroTrust.security.title")}</div>
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <AuthingButton
              style={{ marginRight: 24 }}
              onClick={() => {
                window.open(
                  "https://www.authing.cn/blog/435?keyword=%E9%9B%B6%E4%BF%A1%E4%BB%BB&page=2"
                );
              }}
            >
              {t("zeroTrust.security.detail")}
            </AuthingButton>
            <div
              className="zero-trust-button"
              onClick={() => {
                window.open(
                  "https://www.authing.cn/authingform?fromTag=零信任落地页02"
                );
              }}
            >
              {t("common.button.consult")}
            </div>
          </div>

          <div className="zero-security-card">
            <div className="zero-security-img">
              <img
                src="//files.authing.co/authing-website/zero-trust-security.png"
                alt="authing"
              />
            </div>
            <div className="zero-security-content">
              <div className="title">
                {t("zeroTrust.security.content-title")}
              </div>
              <div className="descript-list">
                {t("zeroTrust.security.descript-list1")}
              </div>
              <div className="descript-list">
                {t("zeroTrust.security.descript-list2")}
              </div>
              <div className="descript-list">
                {t("zeroTrust.security.descript-list3")}
              </div>
              <div className="descript-extra">
                {t("zeroTrust.security.extra")}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
